
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 2.333a5.537 5.537 0 00-.142 11.072.941.941 0 01.257 0h.083A5.538 5.538 0 0014 2.333z","fill":"#bac1cc","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M19.927 16.52a11.584 11.584 0 00-11.842 0 4.571 4.571 0 00-2.298 3.757 4.566 4.566 0 002.287 3.745 10.779 10.779 0 005.927 1.645 10.779 10.779 0 005.926-1.645 4.6 4.6 0 002.287-3.768 4.575 4.575 0 00-2.287-3.734z","fill":"#bac1cc","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M16.135 21.082h-4.258a.805.805 0 110-1.61h4.258a.807.807 0 01.805.8.814.814 0 01-.805.81z","fill":"#bac1cc"}})])
          )
        }
      }
    